/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Represents supported payment merchants and distribution platforms used for processing purchases or issuing bonuses.
 * @export
 * @enum {string}
 */
export var FxIdDomainStoreEnumsMerchant;
(function (FxIdDomainStoreEnumsMerchant) {
    FxIdDomainStoreEnumsMerchant[FxIdDomainStoreEnumsMerchant["Yookassa"] = 0] = "Yookassa";
    FxIdDomainStoreEnumsMerchant[FxIdDomainStoreEnumsMerchant["Xsolla"] = 1] = "Xsolla";
    FxIdDomainStoreEnumsMerchant[FxIdDomainStoreEnumsMerchant["Odnoklassniki"] = 2] = "Odnoklassniki";
    FxIdDomainStoreEnumsMerchant[FxIdDomainStoreEnumsMerchant["VkontakteCom"] = 3] = "VkontakteCom";
    FxIdDomainStoreEnumsMerchant[FxIdDomainStoreEnumsMerchant["VkontaktePlay"] = 4] = "VkontaktePlay";
    FxIdDomainStoreEnumsMerchant[FxIdDomainStoreEnumsMerchant["YandexGames"] = 5] = "YandexGames";
    FxIdDomainStoreEnumsMerchant[FxIdDomainStoreEnumsMerchant["AbsoluteGames"] = 6] = "AbsoluteGames";
    FxIdDomainStoreEnumsMerchant[FxIdDomainStoreEnumsMerchant["Kongregate"] = 7] = "Kongregate";
    FxIdDomainStoreEnumsMerchant[FxIdDomainStoreEnumsMerchant["Stripe"] = 8] = "Stripe";
    FxIdDomainStoreEnumsMerchant[FxIdDomainStoreEnumsMerchant["FacebookGames"] = 9] = "FacebookGames";
    FxIdDomainStoreEnumsMerchant[FxIdDomainStoreEnumsMerchant["MoneyMailRu"] = 10] = "MoneyMailRu";
    FxIdDomainStoreEnumsMerchant[FxIdDomainStoreEnumsMerchant["Bank131"] = 11] = "Bank131";
    FxIdDomainStoreEnumsMerchant[FxIdDomainStoreEnumsMerchant["WizQ"] = 12] = "WizQ";
    FxIdDomainStoreEnumsMerchant[FxIdDomainStoreEnumsMerchant["RuStore"] = 13] = "RuStore";
    FxIdDomainStoreEnumsMerchant[FxIdDomainStoreEnumsMerchant["Telegram"] = 14] = "Telegram";
    FxIdDomainStoreEnumsMerchant[FxIdDomainStoreEnumsMerchant["GooglePlay"] = 15] = "GooglePlay";
    FxIdDomainStoreEnumsMerchant[FxIdDomainStoreEnumsMerchant["AppStore"] = 16] = "AppStore";
    FxIdDomainStoreEnumsMerchant[FxIdDomainStoreEnumsMerchant["Steam"] = 17] = "Steam";
    FxIdDomainStoreEnumsMerchant[FxIdDomainStoreEnumsMerchant["OneStore"] = 18] = "OneStore";
    FxIdDomainStoreEnumsMerchant[FxIdDomainStoreEnumsMerchant["FacebookInstantGames"] = 19] = "FacebookInstantGames";
    FxIdDomainStoreEnumsMerchant[FxIdDomainStoreEnumsMerchant["EpicGamesStore"] = 20] = "EpicGamesStore";
    FxIdDomainStoreEnumsMerchant[FxIdDomainStoreEnumsMerchant["PromoCode"] = 21] = "PromoCode";
    FxIdDomainStoreEnumsMerchant[FxIdDomainStoreEnumsMerchant["YandexGamesBonusMerchant"] = 22] = "YandexGamesBonusMerchant";
    FxIdDomainStoreEnumsMerchant[FxIdDomainStoreEnumsMerchant["Aghanim"] = 23] = "Aghanim";
    FxIdDomainStoreEnumsMerchant[FxIdDomainStoreEnumsMerchant["CrazyGames"] = 24] = "CrazyGames";
    FxIdDomainStoreEnumsMerchant[FxIdDomainStoreEnumsMerchant["CrossPlay"] = 25] = "CrossPlay";
    FxIdDomainStoreEnumsMerchant[FxIdDomainStoreEnumsMerchant["WeChat"] = 26] = "WeChat";
    FxIdDomainStoreEnumsMerchant[FxIdDomainStoreEnumsMerchant["Plutus"] = 27] = "Plutus";
    FxIdDomainStoreEnumsMerchant[FxIdDomainStoreEnumsMerchant["Dummy"] = 100] = "Dummy";
    FxIdDomainStoreEnumsMerchant[FxIdDomainStoreEnumsMerchant["NUMBER_unknown_default_open_api"] = 11184809] = "NUMBER_unknown_default_open_api";
})(FxIdDomainStoreEnumsMerchant || (FxIdDomainStoreEnumsMerchant = {}));
export function instanceOfFxIdDomainStoreEnumsMerchant(value) {
    for (const key in FxIdDomainStoreEnumsMerchant) {
        if (Object.prototype.hasOwnProperty.call(FxIdDomainStoreEnumsMerchant, key)) {
            if (FxIdDomainStoreEnumsMerchant[key] === value) {
                return true;
            }
        }
    }
    return false;
}
export function FxIdDomainStoreEnumsMerchantFromJSON(json) {
    return FxIdDomainStoreEnumsMerchantFromJSONTyped(json, false);
}
export function FxIdDomainStoreEnumsMerchantFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function FxIdDomainStoreEnumsMerchantToJSON(value) {
    return value;
}
export function FxIdDomainStoreEnumsMerchantToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=FxIdDomainStoreEnumsMerchant.js.map